import { Component, Input, Output, EventEmitter, inject } from '@angular/core';
import { CommonModule } from '@angular/common';
import { DialogModule } from 'primeng/dialog';
import { TableModule } from 'primeng/table';
import { AvatarModule } from 'primeng/avatar';
import { ButtonModule } from 'primeng/button';
import { ProgressSpinnerModule } from 'primeng/progressspinner';
import { ComponentChange, ComponentChangeDetail } from '../view-changes.types';
import { TranslateModule, TranslateService } from '@ngx-translate/core';
import { RepoManagementService } from '../../repo-management.service';
import { GlobalConstants } from 'src/app/base/global.constants';
import { UtilService } from 'src/app/services/util.service';

@Component({
  selector: 'app-all-changes-dialog',
  standalone: true,
  imports: [CommonModule, DialogModule, TableModule, AvatarModule, ButtonModule, TranslateModule, ProgressSpinnerModule],
  templateUrl: './all-changes-dialog.component.html',
  styleUrls: ['./all-changes-dialog.component.scss']
})
export class AllChangesDialogComponent {
  private readonly repoService = inject(RepoManagementService);
  private readonly utilService = inject(UtilService);
  private readonly translateService = inject(TranslateService);

  // Constants
  readonly dateTimeFormat = GlobalConstants.defaultDateTimeDisplayFormat;

  @Input() visible = false;
  @Input() component: ComponentChange | null = null;
  @Input() changes: ComponentChangeDetail[] = [];
  @Input() loading = false;

  @Output() readonly visibleChange = new EventEmitter<boolean>();
  @Output() readonly dialogClose = new EventEmitter<void>();

  onHide(): void {
    this.visible = false;
    this.visibleChange.emit(false);
    this.dialogClose.emit();
  }

  getAuthorBgColor(author: string): string {
    return this.repoService.getBgColor(author);
  }

  getAuthorDisplayName(authorId: string): string {
    if (!authorId) {
      return '';
    }
    return this.utilService.getNameFromAppMetaInfo(authorId) || authorId;
  }

  getRemarks(detail: ComponentChangeDetail): string {
    if (detail.mergeLog) {
      return this.translateService.instant('CHANGES_BY_MERGE');
    }
    if (detail.action?.toLowerCase().includes('rename') && (detail.oldValue || detail.newValue)) {
      const parts: string[] = [];
      if (detail.oldValue) {
        parts.push(`${this.translateService.instant('OLD_VALUE')}: ${detail.oldValue}`);
      }
      if (detail.newValue) {
        parts.push(`${this.translateService.instant('NEW_VALUE')}: ${detail.newValue}`);
      }
      return parts.join('\n');
    }
    return '';
  }
}
